const InfoData = ({ label, value, units, date, unitFormatter }) => (
    <div className='info-data'>
        <p className='data-label'>{label}</p>
        <p className='data-value'>
            {value} {unitFormatter && unitFormatter(units)}{' '}
            {date && <span className='titleLabelDate'>{date}</span>}
        </p>
    </div>
);

export default InfoData;